import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const DaftarPrPage = lazy(() => import('./pages/daftar-pr'))
const DetailPrPage = lazy(() => import('./pages/detail-pr'))
const ApprovalPrPage = lazy(() => import('./pages/approval-pr'))
const InboundReceivingPage = lazy(() => import('./pages/inbound-receiving'))
const ArrivalCreatePage = lazy(() => import('./pages/inbound-receiving/features/arrival-batch-log'))
const ArrivalDetailPage = lazy(() => import('./pages/inbound-receiving/features/arrival-detail'))
const PalletizingPage = lazy(() => import('./pages/inbound-receiving/features/palletizing-workbench'))
const TobaccoReceiptDetailPage = lazy(() => import('./pages/inbound-receiving/features/tobacco-receipt-chain'))

/**
 * Cluster C03 Procurement — PRC-01 (daftar-pr), PRC-02 (detail-pr), PRC-03 (approval-pr),
 * PRC-05 + IRM-10 (inbound-receiving: kedatangan, palletizing, penerimaan tembakau).
 */
const procurementRoutes: RouteObject[] = [
  {
    path: 'procurement',
    children: [
      {
        path: 'daftar-pr',
        children: [
          { index: true, element: <DaftarPrPage /> },
          { path: ':id', element: <DetailPrPage /> }
        ]
      },
      {
        path: 'approval-pr',
        children: [
          { index: true, element: <ApprovalPrPage /> },
          { path: ':id', element: <DetailPrPage /> }
        ]
      },
      {
        path: 'inbound-receiving',
        children: [
          { index: true, element: <InboundReceivingPage /> },
          { path: 'arrival/new', element: <ArrivalCreatePage /> },
          /* v7.50 U-01: Detail Kedatangan Material sebagai halaman (menggantikan ArrivalDetailModal). */
          { path: 'arrival/:arrivalNo', element: <ArrivalDetailPage /> },
          { path: 'palletizing', element: <PalletizingPage /> },
          { path: 'tobacco/:id', element: <TobaccoReceiptDetailPage /> }
        ]
      }
    ]
  }
]

export default procurementRoutes
